import moment from "moment";

export const convertToDateTime = (date: string) => {
  return moment(date).format("DD/MM/YYYY HH:mm:ss");
};

export const convertToDate = (date: string) => {
  return moment(date).format("DD/MM/YYYY");
};
